import { useMutation, useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { chainQueryKeys } from './useGetChains';

interface ChainProperty {
  id: string;
  name: string;
  channel_manager: string | null;
}

interface ChainDetectionResult {
  runId: string;
  submittedPropertyIds: Array<string>;
  failedPropertyIds: Array<string>;
  skippedPropertyIds: Array<string>;
}

export function useGetChainProperties(chainId?: string) {
  return useQuery<Array<ChainProperty>>({
    queryKey: [...chainQueryKeys.all, 'properties', chainId],
    queryFn: async () => (await ReservationService.getChainProperties(chainId)).result,
    enabled: !!chainId,
  });
}

export function useDetectChainMissingProducts() {
  return useMutation<ChainDetectionResult, Error, { chainId: string; runId: string }>({
    mutationFn: async ({ chainId, runId }) =>
      (await ReservationService.detectChainMissingProducts(chainId, runId)).result,
  });
}
